import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'bankAccountFormat',
	standalone: true,
})
export class BankAccountFormatPipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) {
			return '';
		}

		const digitsOnly = value.replace(/\D+/g, '');
		if (digitsOnly.length <= 2) return digitsOnly;

		const firstTwo = digitsOnly.slice(0, 2);
		const restGroups = digitsOnly.slice(2).match(/.{1,4}/g) ?? [];

		return [firstTwo, ...restGroups].join(' ');
	}
}
